<template>
    <div v-if="currentSortOrder">
        <span class="sort-label" @click="$refs.list.toggle()">Sort by {{ currentSortOrder.label }}
        <ui-popover open-on="manual" ref="list">
            <div>
                <ul>
                    <li v-for="order in availableSortOrders" @click="selectSortOrder(order)">{{ order.label }}</li>
                </ul>
            </div>
        </ui-popover></span>
    </div>
</template>

<script>
    export default {
        computed: {
            availableSortOrders() {
                return this.$store.state.dataView.availableSortOrders
            },
            currentSortOrder() {
                if (this.availableSortOrders) {
                    return this.availableSortOrders.find(i =>
                        i.value === this.$store.state.dataView.currentSortOrder
                    )
                }
            }
        },
        methods: {
            selectSortOrder(order) {
                this.$store.commit('dataView/setSortOrder', order.value)

                this.$emit('input', order);

                this.$refs.list.close()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .sort-label {
        padding: .15rem .5rem;
        border-radius: 10px;
        background: #f8f8f8;
        display: inline-block;
        margin: 0.5rem .25rem;
        font-weight: bold;
        cursor: pointer;
        color: #999;
        &:hover {
            background: #efefef;
        }
    }
    ul {
        list-style: none;
        margin: 0; padding: 0;
        li {
            padding: .5rem 1rem;
            border-bottom: 1px solid #ccc;
        }
    }
</style>